import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { APP_NAME } from '../../utils/constant';
import { CustomSegment } from '../../components';
import ProfileDetails from './profileDetails';
import ChangePassword from './changePassword';
import Settings from './settings';
import './auth.scss';

class Profile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { t } = this.props;
    document.title = `${t('auth.pages.user_profile')} | ${APP_NAME}`;
  }

  render() {
    const { user, isSuperAdmin, t } = this.props;

    return (
      <Grid.Row>
        <CustomSegment
          title={t('auth.user_profile.profile_details')}
          subTitle={isSuperAdmin && user?.id ? `#${user.id}` : ''}
          className="profile-details"
        >
          <ProfileDetails />
        </CustomSegment>

        <CustomSegment
          title={t('auth.user_profile.change_password')}
          extraMargin
          className="profile-details"
        >
          <ChangePassword />
        </CustomSegment>

        <Settings />
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authentication.user,
    isSuperAdmin: state.authentication.isSuperAdmin,
  };
};

export default connect(mapStateToProps, null)(withTranslation()(Profile));
